import { render, staticRenderFns } from "./reportDetail.vue?vue&type=template&id=2bdd0734&scoped=true&"
import script from "./reportDetail.vue?vue&type=script&lang=js&"
export * from "./reportDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaDetails.less?vue&type=style&index=0&id=2bdd0734&lang=less&scoped=true&"
import style1 from "./reportDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd0734",
  null
  
)

component.options.__file = "reportDetail.vue"
export default component.exports